window.onload = function () {
    var footerModal = document.getElementById('footer-chat-popup');
    var contactBridalStyle = document.getElementById('chat-with-us');

    if (contactBridalStyle) {
        contactBridalStyle.addEventListener('click', openChatFooter);
    }
    if (footerModal) {
        footerModal.addEventListener('click', openChatFooter);

        //operational hours condition
        if (operationalHours() == 'closed') {
            footerModal.parentElement.style.display = 'none'
        }
    }
}

function openChatFooter() {
    loadChatScript('https://static.zdassets.com/ekr/snippet.js?key=de12b1c1-72f4-4580-a5b0-ccf3a02af33a').then(() => {
        setTimeout(() => {
            window.location.href = 'javascript:%24zopim.livechat.window.show();'
        }, 1000);
    })
}

function operationalHours() {
    var d = new Date();
    var n = d.getDay();
    var now = d.getHours() + "." + d.getMinutes();
    var weekdays = [
        ["Sunday"], // we are closed!
        ["Monday", 9.00, 17.00],
        ["Tuesday", 9.00, 17.00],
        ["Wednesday", 9.00, 17.00],
        ["Thursday", 9.00, 17.00],
        ["Friday", 9.00, 17.00],
        ["Saturday"] // we are closed!
    ];
    var day = weekdays[n];

    if (now > day[1] && now < day[2] || now > day[3] && now < day[4]) {
        return 'open'
    } else {
        return 'closed'
    }
}

function loadChatScript(src) {
    return new Promise(function (resolve, reject) {
        const s = document.createElement('script');
        let r = false;
        s.src = src;
        s.id = 'ze-snippet'
        s.onload = s.onreadystatechange = function () {
            if (!r && (!this.readyState || this.readyState == 'complete')) {
                r = true;
                resolve();
            }
        };
        const t = document.getElementsByTagName('script')[0];
        if (document.getElementsByTagName('script')[0].id != "ze-snippet") {
            t.parentElement.insertBefore(s, t);
        } else {
            r = true;
            resolve();
        }
    });
}